import { Helmet as ReactHelmet } from 'react-helmet';

export function PublicPageHelmet() {
  return (
    <ReactHelmet>
      <style>{'body { background-color: #fff; }'}</style>
    </ReactHelmet>
  );
}
